import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.js';
import { MockModeBanner } from './MockModeBanner.js';

const NAV_ITEMS: Array<{ to: string; label: string; end?: boolean; adminOnly?: boolean }> = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/pipeline', label: 'Pipeline' },
  { to: '/jobs', label: 'Jobs' },
  { to: '/candidates', label: 'Candidates' },
  { to: '/settings', label: 'Settings', adminOnly: true },
];

/** App shell: dark sidebar nav + user menu, mock-mode banner, routed content. */
export function Layout() {
  const { user, logout } = useAuth();

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar__brand">
          <span className="sidebar__logo">TT</span>
          <span className="sidebar__name">TipsTrack</span>
        </div>
        <nav className="sidebar__nav" aria-label="Main">
          {NAV_ITEMS.filter((item) => !item.adminOnly || user?.role === 'admin').map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `sidebar__link${isActive ? ' is-active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar__user">
          <div className="sidebar__user-info">
            <span className="sidebar__user-name" title={user?.email}>
              {user?.name ?? user?.email}
            </span>
            <span className="sidebar__user-role">{user?.role}</span>
          </div>
          <button type="button" className="btn btn--ghost btn--sm" onClick={logout}>
            Log out
          </button>
        </div>
      </aside>
      <div className="app-main">
        <MockModeBanner />
        <main className="app-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
